import { Color } from "three"
import { Vector3 } from "three"

import { colors, multiplier as initMultiplier } from "./constants"

export const getValues = (values) =>
  Object.fromEntries(Object.entries(values).map((a) => [a[0], a[1].value]))

export const getPoints = (box) => {
  const points = [
    new Vector3(),
    new Vector3(),
    new Vector3(),
    new Vector3(),
    new Vector3(),
    new Vector3(),
    new Vector3(),
    new Vector3(),
  ]

  points[0].set(box.min.x, box.min.y, box.min.z) // 000
  points[1].set(box.min.x, box.min.y, box.max.z) // 001
  points[2].set(box.min.x, box.max.y, box.min.z) // 010
  points[3].set(box.min.x, box.max.y, box.max.z) // 011
  points[4].set(box.max.x, box.min.y, box.min.z) // 100
  points[5].set(box.max.x, box.min.y, box.max.z) // 101
  points[6].set(box.max.x, box.max.y, box.min.z) // 110
  points[7].set(box.max.x, box.max.y, box.max.z) // 111

  return points
}

export const findGlowColor = (color, multiplier = initMultiplier) => {
  const glowColor = new Color(color)

  const maxKey = Object.keys(glowColor).reduce((a, b) =>
    glowColor[a] > glowColor[b] && a !== "isColor" ? a : b
  )
  const coeff = 1 / glowColor[maxKey]
  glowColor.multiplyScalar(coeff * multiplier)
  return glowColor
}

export const findPaleColor = (color) => {
  const paleColor = new Color(color)
  const groundColor = new Color(colors.bg)
  paleColor.lerp(groundColor, 0.95)
  return paleColor
}
